"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCHANGE_TICKERS = void 0;
const fiat_balance_1 = require("./fiat-balance");
const crypto_1 = require("./crypto");
exports.EXCHANGE_TICKERS = [...crypto_1.CRYPTO_TICKERS, ...fiat_balance_1.FIAT_BALANCE_TICKERS];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhjaGFuZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGlja2Vycy9leGNoYW5nZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxpREFBcUQ7QUFDckQscUNBQXlDO0FBRTVCLFFBQUEsZ0JBQWdCLEdBQUcsQ0FBQyxHQUFHLHVCQUFjLEVBQUUsR0FBRyxtQ0FBb0IsQ0FBQyxDQUFBIn0=